import styled from 'styled-components'
import breakpoints from '../../config/settings/breakpoints'

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors?.background || theme.background};
  display: grid;
  gap: 0;
  grid-template-areas:
    'header'
    'profile'
    'about'
    'skills'
    'experience'
    'projects'
    'practice'
    'footer';
  grid-template-columns: 1fr;

  @media ${breakpoints.device.sm} {
    grid-template-areas:
      'header header header'
      'profile profile profile'
      '. about .'
      '. skills .'
      '. experience .'
      '. projects .'
      '. practice .'
      '. footer .';
    grid-template-columns: 1fr minmax(0, 1280px) 1fr;
  }
`

export const Header = styled.header`
  backdrop-filter: blur(16px) saturate(1.1);
  background-color: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(18, 24, 22, 0.82)'
      : 'rgba(247, 248, 245, 0.82)'};
  border-block-end: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  display: grid;
  grid-area: header;
  grid-template-areas: '. header-content .';
  grid-column: 1 / -1;
  grid-template-columns: 1fr minmax(0, 1280px) 1fr;
  inset-block-start: 0;
  position: sticky;
  z-index: 10;
`

export const Footer = styled.footer`
  display: grid;
  grid-template-areas: '. footer-content .';
  grid-area: footer;
  grid-column: 1 / -1;
  grid-template-columns: 1fr minmax(0, 1280px) 1fr;
  margin-block-start: 1rem;
`
